import React from 'react'

export default function Loader () {
  return <div className="developer-map-loader"><span>Загрузка</span></div>
}